var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlant = function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 18.8c-.4-2.6.1-5 1-6.5.1-.1.3-.1.3 0C6.1 14.1 8 15 9.9 15c3.7 0 7.9-2.5 8-11.6 0-.2-.2-.3-.3-.2C13 6.9 13.9 4 9 4 6.6 4 4.3 5.8 4 8.5c0 .2.2.3.3.1 1.9-1.7 5.3-3.5 9.4-.6.2.1 0 .4-.2.4-6-2-12.4 2.7-12.5 10.5 0 0 .1.1.2.1h2.4c.1 0 .2-.1.2-.2z"
  })));
};
export default SvgPlant;